const CompanionConfig = (props = {}) => {
  if (!props?.companionUrl?.length) {
    throw new Error('Missing required prop companionUrl');
  }
  return {
    companionUrl: props.companionUrl,
    companionHeaders: { 'Access-Control-Allow-Origin': '*' },
    headers: { 'Access-Control-Allow-Origin': '*' },
  };
};

export default CompanionConfig;
